import React from "react";
import { Chip, Tooltip } from "@mui/material";
import useStyles from "../style/js-style/components/EAChipStyle"

const EAChip = ({ label, color, fontWeight = 400, tooltip = "" }) => {
    const { classes } = useStyles();
    return (
        <>
            {tooltip !== "" ? (
                <Tooltip title={tooltip}>
                    <Chip
                        className={classes.root}
                        style={{ color, borderColor: color, fontWeight: fontWeight }}
                        label={label}
                        variant="outlined"
                        size="small"
                        color="default"
                    />
                </Tooltip>
            ) : (
                <Chip
                    className={classes.root}
                    style={{ color, borderColor: color, fontWeight: fontWeight }}
                    label={label}
                    variant="outlined"
                    size="small"
                    color="default"
                />
            )}
        </>
    )
}
export default EAChip;
